import useUsuarioStore from "@/store/usuario";
import useSolicitudEncargoStore from "@/store/solicitudEncargo";

export default [
  // tablero
  {
    title: "Inicio y Creación",
    icon: "fa-hand-sparkles",
    fontAwesome: true,
    children: [
      {
        title: "Tablero",
        icon: "fa-house",
        fontAwesome: true,
        tagVariant: "light-warning",
        route: "home",
        resource: "Home",
        action: "read",
        exact: true,
      },
      {
        title: "Crear Biografía",
        route: "biografia.configurar",
        action: "read",
        resource: "Biografías",
        icon: "fa-pen-to-square",
        fontAwesome: true,
      },
    ],
  },
  {
    title: "Mi contenido",
    icon: "fa-user-gear",
    fontAwesome: true,
    children: [
      {
        title: "Mis Biografías",
        route: "biografia.list",
        action: "read",
        resource: "Biografías",
        icon: "fa-book-open",
        fontAwesome: true,
      },
      {
        title: "Mis Portadas",
        route: "portada.list",
        action: "read",
        resource: "Portadas",
        icon: "fa-palette",
        fontAwesome: true,
      },
    ],
  },

  {
    title: "Transacciones",
    icon: "fa-wallet",
    fontAwesome: true,
    children: [
      {
        title: "Mi Billetera",
        icon: "fa-wallet",
        fontAwesome: true,
        route: "billetera",
        resource: "Billetera",
        action: "read",
      },

      {
        title: "Tienda",
        icon: "fa-store",
        fontAwesome: true,
        route: "tienda",
        resource: "Tienda",
        action: "read",
      },
      {
        title: "Suscripciones ",
        route: "subscripcion.list",
        action: "read",
        resource: "Suscripciones",
        icon: "fa-calendar-check",
      },
      {
        title: "Mis compras",
        route: "compra.list",
        action: "read",
        resource: "Compras",
        icon: "fa-receipt",
      },
    ],
  },

  {
    title: "Encargos",
    icon: "fa-pen-nib",
    fontAwesome: true,
    children: [
      {
        title: "Inbox",
        route: "inbox",
        action: "read",
        resource: "Inbox",
        icon: "fa-message",
      },

      {
        title: "Solicitud de encargo",
        route: "solicitud.encargo.list",
        action: "read",
        resource: "Encargos",
        icon: "fa-file-lines",
        tag: true,
        tagVariant: "secondary",
        tagValue: async () => {
          try {
            const solicitud_encargo_store = useSolicitudEncargoStore();
            const { cantidad } =
              await solicitud_encargo_store.getSolicitudesPendientesCount();
            return `${cantidad} Pendientes`;
          } catch (error) {
            return 0;
          }
        },
      },

      {
        title: "Encargos",
        route: "encargo.list",
        action: "read",
        resource: "Encargos",
        icon: "fa-briefcase",
        tagVariant: "secondary",
        tag: true,
        tagValue: async () => {
          try {
            const usuario_store = useUsuarioStore();
            const { cantidad } =
              await usuario_store.getEncargosPendientesCount();
            return `${cantidad} Pendientes`;
          } catch (error) {
            return 0;
          }
        },
      },

      {
        title: "Configurar perfil",
        route: "configurar.autor.encargo",
        action: "read",
        resource: "Perfil de autor por encargos",
        icon: "fa-gear",
      },
    ],
  },

  {
    title: "Comunidad y Ayuda",
    icon: "fa-hand-holding-heart",
    fontAwesome: true,
    children: [
      {
        title: "Salón de los Inmortales",
        route: "salon.inmortales",
        action: "read",
        resource: "Salón de los Inmortales",
        icon: "fa-trophy",
      },
      {
        title: "Academia",
        route: "academia",
        action: "read",
        resource: "Academia",
        icon: "fa-graduation-cap",
      },
      {
        title: "Soporte",
        route: "soporte",
        action: "read",
        resource: "Soporte",
        icon: "fa-circle-question",
      },
    ],
  },
];
